const permissionLevels = {
    DEFAULT: ["Not Allow", "Allow"],
    READ_WRITE: ["Not Allow", "Read", "Write"],
    READ_ONLY: ["Not Allow", "Read"],
};

const permissionsList = [
    "attendence",
    "feemanagement",
    "courses",
    "bug",
    "dashboardAllow",
];

const readOnlyList = ["users"];

const defaultList = [
    "usersBan",
    "usersDelete",
    "courseTransfer",
    "amountUpdate",
    "activity",
    "studentactivity",
    "quiz",
    "results",
    "certificate",
];

const permissionsData = Object.fromEntries([
    ...permissionsList.map((key) => [key, permissionLevels.READ_WRITE]),
    ...readOnlyList.map((key) => [key, permissionLevels.READ_ONLY]),
    ...defaultList.map((key) => [key, permissionLevels.DEFAULT]),
]);

export default permissionsData;
